import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconFlag({ color = '#000000', title, ...rest }: IconProps): ReactElement {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' {...rest} xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <g fill='none' fillRule='evenodd' transform='translate(-1268 -600)'>
                <g transform='translate(62 377)' fill={color}>
                    <g transform='translate(4 56)'>
                        <g transform='translate(0 14)'>
                            <g transform='translate(1202 153)'>
                                <polygon points='2 24 0 24 0 0 2 0' />
                                <polygon points='20 2 4 2 4 14 20 14 16 8.031' />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
